import React, { Fragment, useState } from "react";
import { Card } from "react-bootstrap";
import {
    Checkbox,
    Button,
    Box,
    Switch,
    FormGroup,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core"; import { FormControlLabel, IconButton, TextField, MenuItem } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { buttonStyle } from "../../../Style/ManualStyle";
import { useDispatch, useSelector } from "react-redux";
import { getAllJobs, setBackendJobs } from "../../../Utils/actions";
import { loadingOn } from "../../../Utils/utils";
import cogoToast from "cogo-toast";

const Cluster = () => {

    const dispatch = useDispatch();
    const [form, setForm] = useState({
        isCluster: "N",
        clusterTime: "0",
    });
    const [error, setError] = useState({
        isCluster: "",
        clusterTime: "",
    });
    const textFields = {
        margin: "5px",
        padding: "10px",
        height: "70px",
        gap: "15px",
    };
    const textFld = { margin: "5px", padding: "0px", display: "flex" };
    const switchtextFld = { marginLeft: "10px", display: "block" };
    const [openConfirm, setOpenConfirm] = useState(false);

    const handleOpenConfirm = () => {
        setOpenConfirm(true);
    };
    const handleSetting = (e) => {
        let value = e.target.value === "0" ? "" : e.target.value;
        setForm({ ...form, [e.target.name]: value });
    };

    const handleCheckChange = (e) => {
        setError({ ...error, [e.target.name]: "" });
        setForm({ ...form, [e.target.name]: e.target.value === "Y" ? "N" : "Y" });
    };

    const handleChange = (e) => {
        setError({ ...error, [e.target.name]: "" });
        setForm({ ...form, [e.target.name]: e.target.value.toString() });
    };

    const handleCloseConfirm = () => {
        setOpenConfirm(false);
    };

    const handleConfirmSubmit = (e) => {
        handleSubmit(e);
        handleCloseConfirm();
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = { ...error };

        // Validate all fields
        if (!form.clusterTime.trim()) newErrors.clusterTime = "Cluster Time is required";

        // Update error state with all errors
        setError(newErrors);

        // Check for any errors
        const hasErrors = Object.values(newErrors).some((err) => err !== "");
        if (hasErrors) {
            console.log("Errors found:", newErrors); // Debugging
            return;
        }

        // Proceed with submission
        const data = [
            {
                propertyKey: "iot.server.isCluster",
                propertyValue: form.isCluster,
            },
            {
                propertyKey: "iot.server.cluster.ping.ms",
                propertyValue: form.clusterTime,
            },
        ];

        try {
            dispatch(loadingOn());
            dispatch(setBackendJobs(data));
        } catch (err) {
            cogoToast.error("Not successful");
            console.error("Submission error:", err); // Debugging
        }
    };

    return (<>
        <Card
            className={"shadow-none w-100 backendjobs-card no-padding"}
            style={{
                backgroundColor: "#333333",
                overflow: "auto",
                height: "89vh",
                border: "none",
                borderRadius: "unset",
                padding: 0,
            }}
        >
            <Card.Body
                className={"backendjobs_content"}
                style={{
                    borderRadius: "0.25rem",
                    background: "#fff",
                    overflow: "auto",
                    backgroundColor: "#242424",
                    padding: 0
                }}
            >
                <div
                    className="col-md-10 backfill-form"
                    style={{ paddingTop: "5px", paddingLeft: "5px" }}
                >
                    <Box
                        component="form"
                        className="addUserBox"
                        onSubmit={(e) => e.preventDefault()}
                        noValidate
                        autoComplete="off"
                    >
                        <div className="textBoxes d-block">
                            <div className="main1">
                                <div

                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "20px", // space between items
                                        // marginBottom: "30px",
                                    }}
                                >
                                    {/* Cluster Checkbox */}
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    sx={{
                                                        "& .MuiSvgIcon-root": { fontSize: 28 },
                                                        color: "#286685",
                                                        "&.Mui-checked": { color: "#286685" },
                                                    }}
                                                />
                                            }
                                            value={form.isCluster}
                                            onChange={handleCheckChange}
                                            checked={form.isCluster === "Y"}
                                            name="isCluster"
                                            label="Cluster"
                                            style={{ color: "#c7c7c7" }}
                                        />
                                    </FormGroup>

                                    {/* Cluster Time Input */}
                                    <TextField
                                        type="number"
                                        name="clusterTime"
                                        label="Cluster Time (min)"
                                        value={form.clusterTime}
                                        required
                                        onChange={handleChange}
                                        error={!!error.clusterTime}
                                        helperText={error.clusterTime}
                                        size="small"
                                        style={{flex: "0 0 200px" }} // keep consistent width
                                    />

                                    {/* Save Button */}
                                    <Button
                                        className="submit-btn"
                                        type="button"
                                        startIcon={<SaveIcon />}
                                        style={{
                                            ...buttonStyle,
                                            width: "120px",
                                            marginTop: "0", // align with text field
                                        }}
                                        onClick={handleOpenConfirm}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Box>

                </div>
            </Card.Body>
        </Card>
        <Dialog
            open={openConfirm}
            onClose={handleCloseConfirm}
            aria-labelledby="confirm-dialog-title"
        >
            <DialogTitle
                id="confirm-dialog-title"
                style={{
                    backgroundColor: "#464545fb",
                    color: "#c7c7c7",
                }}
            >
                Confirm Save
            </DialogTitle>

            <DialogContent>
                Are you sure you want to save the changes?
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleCloseConfirm}
                    variant="contained"
                    color="secondary"
                    style={{ ...buttonStyle }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmSubmit}
                    color="primary"
                    variant="contained"
                    startIcon={<SaveIcon />}
                    style={{
                        ...buttonStyle,
                    }}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default Cluster;